import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"

const RECENT_POSTS_QUERY = graphql`
query GetRecentPosts {
  www {
    posts(first: 5) {
      nodes {
        title
        slug
        link
      }
    }
  }
}
`

const RecentPostsWidget = () => (
  <StaticQuery
    query={RECENT_POSTS_QUERY}
    render={data => {
      const { posts } = data.www
      return (
        <section
          id="recent-posts-2"
          className="widget widget_recent_entries"
          style={{ display: "none" }}
        >
          <h2 className="widget-title">Articoli recenti</h2>
          <ul>
            {posts && posts.nodes && posts.nodes.length
              ? posts.nodes.map((post) => (
                  <li key={post.slug}>
                    <Link
                      to={`/${post.link
                        .replace("https://new.startupitalia.eu/", "")
                        .replace("https://admin.startupitalia.eu", "")}`}
                    >
                      {post.title}
                    </Link>
                  </li>
                ))
              : null}
          </ul>
        </section>
      )
    }}
  />
)

export default RecentPostsWidget
